export const partnerLists = {
    partnerItem: [
        {
            partnerName: 'Affinity Water',
            partnerUrl: 'https://offer.homeserve.co.uk/dapproduct?dapproduct=644AA8DB-5B54-4C5B-8604-B451406FEA2D&dapconfig=dc0f4778-6952-4492-92e5-45087a570049'
        },
        {
            partnerName: 'Bournemouth Water',
            partnerUrl: 'https://offer.homeserve.co.uk/dapproduct?dapproduct=644AA8DB-5B54-4C5B-8604-B451406FEA2D&dapconfig=b70b5aec-6cae-43a5-b0fa-b077e1dbaa02'
        },
        {
            partnerName: 'Cambridge Water',
            partnerUrl: 'https://offer.homeserve.co.uk/dapproduct?dapproduct=644AA8DB-5B54-4C5B-8604-B451406FEA2D&dapconfig=3df8e89c-aaa9-4e95-9a72-b46118c95523'
        },
        {
            partnerName: 'Eon',
            partnerUrl: 'https://offer.homeserve.co.uk/page-not-found'
        },
        {
            partnerName: 'Essex & Suffolk Water',
            partnerUrl: '/DapComparison?dapconfig=b0eee6c4-19ec-414f-bddb-fd8f2ebd79aa'
        },
        {
            partnerName: 'Green Energy',
            partnerUrl: 'https://offer.homeserve.co.uk/page-not-found'
        },
        {
            partnerName: 'Northumbrian Water',
            partnerUrl: '/DapComparison?dapconfig=ccea597c-249b-42b5-b6ed-71fcd3b71421'
        },
        {
            partnerName: 'Portsmouth Water',
            partnerUrl: 'https://offer.homeserve.co.uk/dapproduct?dapproduct=644AA8DB-5B54-4C5B-8604-B451406FEA2D&dapconfig=5500b201-4170-458d-8946-e83de80d924c'
        },
        {
            partnerName: 'Shell Energy',
            partnerUrl: 'https://offer.homeserve.co.uk/dapcomparison?dapconfig=04ED4D48-376A-4586-A06A-936615A52499'
        },
        {
            partnerName: 'South Staffs Water',
            partnerUrl: 'https://offer.homeserve.co.uk/dapproduct?dapproduct=644AA8DB-5B54-4C5B-8604-B451406FEA2D&dapconfig=44cd70f1-fadc-4f03-bf35-bd0681afd2cf'
        },
        {
            partnerName: 'South East Water',
            partnerUrl: 'https://offer.homeserve.co.uk/dapproduct?dapproduct=644AA8DB-5B54-4C5B-8604-B451406FEA2D&dapconfig=683e5fd7-d6fd-4e57-9eb5-f6eece3ef89b'
        },
        {
            partnerName: 'South West Water',
            partnerUrl: 'https://offer.homeserve.co.uk/dapproduct?dapproduct=644AA8DB-5B54-4C5B-8604-B451406FEA2D&dapconfig=fef8981f-21a1-4ca4-8086-fc592b204ab2'
        },
    ]
}